module.exports = __webpack_public_path__ + "static/media/SmartShop_1-446w.480f8fd1.png";